import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import { object, func, bool, string, array } from 'prop-types';

import { Popconfirm } from '../../../../../popovers';
import { UserIcon, CloseIcon, Tooltip, CloseIconWrapper } from './styled-components';
import { getAvatarUrl, checkIfCurrentUserSalesAgent } from '../../../../../../utils';


export function AssigneeItem({
  users,
  assignee,
  unassigned,
  currentUserId,
  onRemoveAssignee,
  assigneeIconStyle,
  requestTasks,
  tasks,
}) {
  const [showRemoveIcon, setShowRemoveIcon] = useState(false);
  const { fullName = '', role = '', _id } = assignee;
  const isSales = role === 'sales-agent';
  const currentUserIsSales = checkIfCurrentUserSalesAgent(users);
  const [noTaskToSalesAssigned, setAssignedTask] = useState(currentUserIsSales);
  const isCurrentUser = currentUserId === assignee._id;

  useEffect(() => {
    if (isSales && !currentUserIsSales && requestTasks) {
      const assignedTask = requestTasks.find(task => tasks[task].assignedTo === _id);
      setAssignedTask(!assignedTask);
    }
  }, [requestTasks, tasks]);

  return (
    <Tooltip
      title={unassigned ? 'Unassigned' : R.pathOr('User not found', ['fullName'], assignee)}
    >
      {
        !unassigned && isSales && noTaskToSalesAssigned ? (
          <Popconfirm
            title={`${isCurrentUser ? 'You' : fullName} will lose access to this request when unassigned, continue?`}
            onConfirm={() => onRemoveAssignee(assignee._id, isCurrentUser)}
            getPopupContainer={trigger => trigger.parentElement}
            overlayClassName="popover-action"
          >
            <CloseIconWrapper>
              <CloseIcon
                theme="filled"
                type="close-circle"
                className={showRemoveIcon ? 'show' : ''}
              />
            </CloseIconWrapper>
          </Popconfirm>) :
          (
            <CloseIcon
              theme="filled"
              type="close-circle"
              onClick={() => onRemoveAssignee(assignee._id, currentUserId === assignee._id)}
              className={showRemoveIcon ? 'show' : ''}
            />
          )
      }
      <UserIcon
        tabIndex={0}
        style={assigneeIconStyle}
        src={
          unassigned
            ? getAvatarUrl(null)
            : getAvatarUrl(R.pathOr(null, ['profileImage'], assignee))
        }
        onClick={() => {
          if (onRemoveAssignee) {
            setShowRemoveIcon(true);
          }
        }}
        onBlur={() => {
          if (onRemoveAssignee) {
            setShowRemoveIcon(false);
          }
        }}
      />
    </Tooltip>
  );
}

AssigneeItem.propTypes = {
  users: object,
  assignee: object,
  unassigned: bool,
  currentUserId: string,
  onRemoveAssignee: func,
  assigneeIconStyle: object,
  requestTasks: array,
  tasks: object,
};

AssigneeItem.defaultProps = {
  users: {},
  assignee: {},
  unassigned: false,
  currentUserId: '',
  assigneeIconStyle: {},
  onRemoveAssignee: null,
  requestTasks: null,
  tasks: null,
};



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/assignees-list/assignees-list-item/index.js